import React, { useContext, useState } from "react";
import { TextField, Button, Checkbox, DialogActions, FormGroup, FormControlLabel, Stack, Typography, Backdrop, CircularProgress, Box, MenuItem, Icon, IconButton, Divider } from "@mui/material";
import { API } from "../../conf";
import { Context } from "../../App";
import { banques, compte_type, fedcompte_type, eglise_compte_type } from "../../asset/variables";
import { Add, Delete } from "@mui/icons-material";

const organisation = JSON.parse(sessionStorage.getItem('eglise'))
const agent = JSON.parse(sessionStorage.getItem('user'))

export function CompteForm(props) {
    const { updateConnect } = useContext(Context)
    const [loading, setLoad] = useState(false)
    const [libelle, setLabel] = useState('')
    const [num_compte, setNum] = useState('')
    const [is_offrande, setOffrande] = useState(false)
    const [is_hors_budget, setHorsBdg] = useState(false)
    const [type, setType] = useState('')
    const [banque, setBanque] = useState('')
    const [num_banque, setNumBnque] = useState('')
    const [solde, setSolde] = useState(0)
    const [percent, setPercent] = useState(0)
    const [prevision, setPrevision] = useState(0)
    const [sous_postes, setSousPostes] = useState([])
    const [csp_activated, setCSPActivatedStatus] = useState(false)

    const [msg, setMsg] = useState()

    function handleSubmit() {
        setLoad(true); setMsg()
        var eglise = props.eglise._id
        const ecart = -prevision
        fetch(API.concat(`/comptes/create`), {method: 'POST', headers:{
            Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, 
            body: JSON.stringify({libelle, num_compte, type, banque, num_banque, is_offrande, is_hors_budget,
                customize_sous_postes_activated: csp_activated, sous_postes: sous_postes.filter(sp=>sp.libelle!==''),
                solde, percent, prevision, ecart, eglise})
        }).then(async(response)=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200){
                    const compte = await response.json()
                    props.updateComptes(compte)
                    props.close()
                }
                if(response.status === 403){
                    const text = await response.text()
                    setMsg(text)
                }
                setLoad(false)
            }
        })
    }

    return(
        <Box sx={{paddingInline:'20px', paddingBlock:'30px'}} >
            <Typography variant="h5" textAlign='center'>Ajouter un compte</Typography>
            <Stack direction='column' spacing={2} sx={{paddingTop:'10px'}}>
                <Stack direction='row' spacing={2}>
                    {[...fedcompte_type,'petite-caisse', 'liaison','banque'].includes(type)&&<TextField required={['liaison', 'petite-caisse'].includes(type)} sx={{width:'35%', minWidth:'150px'}} label={"N° compte"}
                    value={num_compte} onChange={(e)=>setNum(e.target.value)}/>}
                    <TextField autoFocus fullWidth required={type!=='petite-caisse'} sx={{minWidth:'200px'}} label="Libellé"
                    value={libelle} onChange={(e)=>setLabel(e.target.value)}
                    />
                </Stack>
                <Stack direction='row' spacing={2}>
                    <TextField select required fullWidth label='Type de compte' sx={{minWidth:'150px'}} value={type} onChange={e=>setType(e.target.value)}>
                        {[...(organisation.type==='fédération' ? [...compte_type, ...fedcompte_type] : agent.level>2 ? compte_type : eglise_compte_type).sort(), 'autre'].flat().map((item, index)=><MenuItem key={index} value={item} sx={{textTransform:'capitalize'}}>{item}</MenuItem>)}
                    </TextField>
                    <TextField type="number" sx={{width:'30%', minWidth:'150px'}} label={"Solde"}
                    value={solde} onFocus={()=>{if(solde===0) setSolde('')}}
                    onChange={(e)=>{if (/^-?\d+(\.\d{1,2})?$/.test(e.target.value)) {setSolde(Number(e.target.value))} else if(e.target.value==='')setSolde('')}}/>
                </Stack>
                {type==='banque'?<Stack direction='row' spacing={2} alignItems='center'>
                    <TextField select label='Banque' required fullWidth value={banque} onChange={e=>setBanque(e.target.value)}>
                        {banques.map((banque, index)=><MenuItem key={index} value={banque}>{banque}</MenuItem>)}
                    </TextField>
                    <TextField required fullWidth label='N° compte bancaire' value={num_banque} onChange={e=>setNumBnque(e.target.value)}/>
                </Stack>
                :<><Stack direction='row' spacing={2}>
                    <TextField type="number" fullWidth sx={{minWidth:'70px'}} label={"Poucentage offrande globale"} disabled={is_hors_budget}
                    onFocus={()=>{if(percent===0) setPercent('')}}
                    value={percent} onChange={(e)=>{
                        if (/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)<=100-props.currentbudget) {
                            setPercent(Number(e.target.value))   
                        } else if(e.target.value==='')setPercent('')
                    }}/>
                    <TextField type="number" fullWidth sx={{ minWidth:'70px'}} label="Budget prévionnel"
                    onAbort={()=>{if(prevision===0) setPrevision('')}}
                    value={prevision} onChange={(e)=>{
                    if (/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)>=0) {
                        setPrevision(Number(e.target.value))   
                    } else if(e.target.value===''){
                        setPrevision('')
                    }
                }}/>
                </Stack>
                
                {![...fedcompte_type,'petite-caisse', 'liaison'].includes(type)&&<FormGroup>
                    <FormControlLabel control={<Checkbox checked={!is_hors_budget} onChange={()=>setHorsBdg(old=>!old)} />} label="offrande globale" />
                    <FormControlLabel control={<Checkbox checked={is_offrande} onChange={()=>setOffrande(old=>!old)} />} label="offrande spécifiée" />
                    <FormControlLabel control={<Checkbox checked={is_hors_budget} onChange={()=>setHorsBdg(old=>!old)} />} label="hors budget" />
                </FormGroup>}
                </>}

                    {props.eglise.type==='fédération'&&<Box display='flex' flexDirection='column'>
                        <Divider sx={{marginBlock:'10px', width:'60%', alignSelf:'center'}} />
                        <Typography variant="subtitle1" fontWeight='bold' align="center">Sous postes</Typography>
                        <FormControlLabel control={<Checkbox checked={csp_activated} onChange={()=>setCSPActivatedStatus(old=>!old)} />} label="Autoriser la création de sous-postes personnalisés" />
                        <Stack direction='column' spacing={1} sx={{marginBlock:2}}>{sous_postes.map((sous_poste, index)=>
                            <Stack direction='row' spacing={2} key={index} alignItems='center'>
                                <TextField fullWidth size="small" label="Libellé" value={sous_poste.libelle} onChange={(e)=>{
                                    setSousPostes(old=>old.map((sp, i)=>(i===index?{...sp, libelle: e.target.value.toUpperCase()}:sp)))}} />
                                <FormControlLabel control={<Checkbox checked={sous_poste.activated} onChange={()=>setSousPostes(old=>old.map((sp, i)=>(i===index?{...sp, activated: !sp.activated}:sp)))}/>} label="Activé" />
                                <IconButton onClick={()=>setSousPostes(old=>old.filter((_, i)=>i!==index))} sx={{color:'error.main'}}>
                                    <Delete fontSize="small" />
                                </IconButton>
                            </Stack>
                        )}</Stack>
                        <IconButton sx={{alignSelf:'center', backgroundColor:'primary.main', color:'white'}} 
                        onClick={()=>setSousPostes(old=>[...old, {libelle:'', activated: false}])}>
                            <Add fontSize="small" />
                        </IconButton>
                    </Box>}

                <Typography variant="info" color='error'>{msg}</Typography>
            </Stack>
            <DialogActions>
                <Button variant="outlined" onClick={props.close}>Annuler</Button>
                <Button variant="contained" disabled={libelle.replaceAll(' ', '').length < 2 || (['liaison', 'petite-caisse'].includes(type)&&num_compte.replaceAll(' ', '').length < 5)} onClick={handleSubmit}>Enregistrer</Button>
            </DialogActions>
            <Backdrop open={loading} ><CircularProgress color="inherit" /></Backdrop>
        </Box>
    )
}




// *********************** EDIT COMPTE FORM *********************** //

export function EditCompteForm(props) {
    const { updateConnect } = useContext(Context)
    const [loading, setLoad] = useState(false)
    const [libelle, setLabel] = useState(props.compte.libelle)
    const [num_compte, setNum] = useState(props.compte.num_compte)
    const [is_offrande, setOffrande] = useState(props.compte.is_offrande)
    const [is_hors_budget, setHorsBdg] = useState(props.compte.is_hors_budget)
    const [type, setType] = useState(props.compte?.type??'')
    const [banque, setBanque] = useState(props.compte?.banque??'')
    const [num_banque, setNumBnque] = useState(props.compte?.num_banque??'')
    const [solde, setSolde] = useState(props.compte.init_solde??'')
    const [percent, setPercent] = useState(props.compte.percent)
    const [prevision, setPrevision] = useState(props.compte.prevision??0)
    const [sous_postes, setSousPostes] = useState(props.compte.sous_postes??[])
    const [csp_activated, setCSPActivatedStatus] = useState(Boolean(props.compte.customize_sous_postes_activated))
    const [msg, setMsg] = useState()

    function handleSubmit() {
        setLoad(true); setMsg()
        fetch(API.concat(`/comptes/${props.compte?.eglise}/${props.compte?._id}`), {method: 'PATCH', headers:{
            Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, 
            body: JSON.stringify({libelle, num_compte, type, banque, num_banque, is_offrande, is_hors_budget, 
                customize_sous_postes_activated: csp_activated, sous_postes: sous_postes.filter(sp=>sp.libelle!==''),
                init_solde: solde, percent, prevision})
        }).then(async(response)=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200){
                    const compte= await response.json()
                    props.updateCompte(compte)
                    props.close()
                }
                if(response.status === 403){
                    const text = await response.text()
                    setMsg(text)
                }
                setLoad(false)
            }
        })
    }

    return(
        <Box component='form' onSubmit={e=>{e.preventDefault();handleSubmit()}} sx={{paddingInline:'20px', paddingBlock:'30px'}} >
            <Typography variant="h5" textAlign='center' marginBottom={3}>Modifier le compte n°{props.compte.num_compte} <span style={{textTransform:'capitalize'}}>{props.compte.libelle}</span></Typography>
            <Stack direction='column' spacing={2} sx={{paddingTop:'10px'}}>
                <Stack direction='row' spacing={2}>
                    {[...fedcompte_type,'petite-caisse', 'liaison', 'banque'].includes(type)&&<TextField required={['liaison', 'petite-caisse'].includes(type)} sx={{width:'35%', minWidth:'150px'}} label={"N° compte"}
                    value={num_compte} onChange={(e)=>setNum(e.target.value)}/>}
                    <TextField autoFocus fullWidth required={type!=='petite-caisse'} sx={{minWidth:'200px'}} label="Libellé"
                    value={libelle} onChange={(e)=>setLabel(e.target.value)}/>
                </Stack>
                <Stack direction='row' spacing={2}>
                    <TextField select required fullWidth label='Type de compte' sx={{minWidth:'150px'}} value={type} onChange={e=>setType(e.target.value)}>
                        {[...(organisation.type==='fédération' ? [...compte_type, ...fedcompte_type] : agent.level>2 ? compte_type : eglise_compte_type).sort(), 'autre'].flat().map((item, index)=><MenuItem key={index} value={item} sx={{textTransform:'capitalize'}}>{item}</MenuItem>)}
                    </TextField>
                    <TextField type="number" sx={{width:'30%', minWidth:'150px'}} label={"Solde initial"}
                    value={solde} onFocus={()=>{if(solde===0) setSolde('')}}
                    onChange={(e)=>{if(/^-?\d+(\.\d{1,2})?$/.test(e.target.value)){setSolde(Number(e.target.value))} else if(e.target.value==='') setSolde('')}}/>
                </Stack>
                {type==='banque'?<Stack direction='row' spacing={2} alignItems='center'>
                    <TextField select label='Banque' required fullWidth value={banque} onChange={e=>setBanque(e.target.value)}>
                        {banques.map((banque, index)=><MenuItem key={index} value={banque}>{banque}</MenuItem>)}
                    </TextField>
                    <TextField required fullWidth label='N° compte bancaire' value={num_banque} onChange={e=>setNumBnque(e.target.value)}/>
                </Stack>
                :<><Stack direction='row' spacing={2}>
                    <TextField type="number" fullWidth sx={{minWidth:'70px'}} label={"Poucentage offrande globale"} disabled={is_hors_budget}
                    value={percent} onFocus={()=>{if(percent===0) setPercent('')}}
                    onChange={(e)=>{
                        if (/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)<=100) {
                            setPercent(Number(e.target.value))   
                        } else if(e.target.value==='')setPercent('')
                    }}/>
                    <TextField type="number" fullWidth sx={{ minWidth:'70px'}} label="Budget prévionnel"
                    value={prevision} onFocus={()=>{if(prevision===0) setPrevision('')}}
                    onChange={(e)=>{
                    if (/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)>=0) {
                        setPrevision(Number(e.target.value))   
                    } else if(e.target.value===''){
                        setPrevision('')
                    }
                }}/>
                </Stack>
                
                {![...fedcompte_type,'petite-caisse', 'liaison'].includes(type)&&<FormGroup>
                    <FormControlLabel control={<Checkbox checked={!is_hors_budget} onChange={()=>setHorsBdg(old=>!old)} />} label="offrande globale" />
                    <FormControlLabel control={<Checkbox checked={is_offrande} onChange={()=>setOffrande(old=>!old)} />} label="offrande" />
                    <FormControlLabel control={<Checkbox checked={is_hors_budget} onChange={()=>setHorsBdg(old=>!old)} />} label="hors budget" />
                </FormGroup>}</>}

                {props.eglise.type==='fédération'&&<Box display='flex' flexDirection='column'>
                    <Divider sx={{marginBlock:'10px', width:'60%', alignSelf:'center'}} />
                    <Typography variant="subtitle1" fontWeight='bold' align="center">Sous postes</Typography>
                    <FormControlLabel control={<Checkbox checked={csp_activated} onChange={()=>setCSPActivatedStatus(old=>!old)} />} label="Autoriser la création de sous-postes personnalisés" />
                    <Stack direction='column' spacing={1} sx={{marginBlock:2}}>{sous_postes.map((sous_poste, index)=>
                        <Stack direction='row' spacing={2} key={index} alignItems='center'>
                            <TextField fullWidth size="small" label="Libellé" value={sous_poste.libelle} onChange={(e)=>{
                                setSousPostes(old=>old.map((sp, i)=>(i===index?{...sp, libelle: e.target.value.toUpperCase()}:sp)))}} />
                            <FormControlLabel control={<Checkbox checked={sous_poste.activated} onChange={()=>setSousPostes(old=>old.map((sp, i)=>(i===index?{...sp, activated: !sp.activated}:sp)))}/>} label="Activé" />
                            <IconButton onClick={()=>setSousPostes(old=>old.filter((_, i)=>i!==index))} sx={{color:'error.main'}}>
                                <Delete fontSize="small" />
                            </IconButton>
                        </Stack>
                    )}</Stack>
                    <IconButton sx={{alignSelf:'center', backgroundColor:'primary.main', color:'white'}} 
                    onClick={()=>setSousPostes(old=>[...old, {libelle:'', activated: false}])}>
                        <Add fontSize="small" />
                    </IconButton>
                </Box>}

                <Typography variant="info" color='error'>{msg}</Typography>
            </Stack>
            <DialogActions>
                <Button variant="outlined" onClick={props.close}>Annuler</Button>
                <Button variant="contained" disabled={libelle.replaceAll(' ', '').length < 2 || (['liaison', 'petite-caisse'].includes(type)&&num_compte.replaceAll(' ', '').length < 5)} type="submit">Enregistrer</Button>
            </DialogActions>
            <Backdrop open={loading} ><CircularProgress color="inherit" /></Backdrop>
        </Box>
    )
}